import dynamic from "next/dynamic"
import { useState } from "react"
import { useMediaPredicate } from "react-media-hook"
import { Spinner } from "../../common/loading/spinner"
import "./previewSheet.module.css"

const PDFPreviewModal = dynamic(() => import("./pdfPreviewModal"))

function PreviewSheet() {
  const [showPDF, setShowPDF] = useState()
  const isMobile = useMediaPredicate("(max-width: 768px)")

  return (
    <>
      <div className="flex justify-center">
        <button
          className="relative flex justify-center flex-grow px-4 py-3 mb-6 font-serif text-base font-bold transition-colors duration-200 bg-transparent border-2 border-black rounded md:flex-grow-0 disabled:cursor-not-allowed"
          disabled={showPDF}
          aria-label="Förhandsgranska gåvobevis"
          type="button"
          onClick={() => setShowPDF(true)}>
          {showPDF && (
            <div className="absolute inset-0 z-10 flex items-center justify-center text-white bg-white border-black rounded">
              <Spinner borderClass="border-black" />
            </div>
          )}
          Förhandsgranska gåvobevis
        </button>
      </div>

      {showPDF && (
        <PDFPreviewModal isMobile={isMobile} setShowPDF={setShowPDF} />
      )}
    </>
  )
}

export default PreviewSheet
